// extracted by mini-css-extract-plugin
export var LightBoxGallery1 = "LightBoxGallery-module--LightBoxGallery1--crDcC";
export var fullWidthContainer = "LightBoxGallery-module--fullWidthContainer--LLWDT";
export var galleryItems = "LightBoxGallery-module--galleryItems---Wuxj";
export var imageInView = "LightBoxGallery-module--imageInView--GTXLH";
export var imageInViewContainer = "LightBoxGallery-module--imageInViewContainer--iKekI";
export var imageInViewContainerImgIn = "LightBoxGallery-module--imageInViewContainerImgIn--4X8YT";
export var leftArrow = "LightBoxGallery-module--leftArrow--+Zgt7";
export var overlayGalleryAppears = "LightBoxGallery-module--overlayGalleryAppears--1x4GH";
export var rightArrow = "LightBoxGallery-module--rightArrow--RSuv3";